import React, { useEffect, useState } from "react";
import { Button, Input, Modal, Popover, Table } from "antd";
import { useNavigate } from "react-router-dom";
// import { getStatusColor } from '../../../util/statusColor';
// import AdminUdateOrderModal from '../../modals/order/AdminUdateOrderModal';
// import AdminProductModal from '../../modals/product/AdminProductModal';
import { AuthContextValue, useAuth } from "../../providers/AuthProvider";
import { useProductList, useDeleteProduct } from "../../api/product";
import AdminProductModal from "../../pages/products/AdminProductModal";
import TableAction from "../TableAction";
import { MoreOutlined } from "@ant-design/icons";
import { getStatusColor } from "../../util/statusColor";

type productTableProps = {
  searchTexts: string;
};

const ProductsTable: React.FC<productTableProps> = ({ searchTexts }) => {
  const [tableData, setTableData] = useState<any[]>([]);
  const [searchText, setSearchText] = useState<string>("");
  const navigate = useNavigate();
  const { data: products, isLoading } = useProductList();
  // const [productsList, setProductsList] = useState([]);
  const { user } = useAuth() as AuthContextValue;
  const roleName = user?.roleName;
  const [open, setOpen] = useState(false);
  const [selectedId, setSelectedId] = useState("");
  const [selectedStatus, setSelectedStatus] = useState<
    | "ACCEPTED"
    | "DELIVERED"
    | "INPROGRESS"
    | "PENDING"
    | "REJECTED"
    | "COMPLETED"
    | undefined
  >();

  const [deleteOpen, setdeleteOpen] = useState(false);
  const [deleteSelectedId, setdeleteSelectedId] = useState("");

  const { mutateAsync: deleteProdct } = useDeleteProduct();
  const productsColumn = [
    // {
    //   title: 'No.',
    //   width: 20,
    //   render: (text: string, record: any, index: number) => <b>#{index + 1}</b>
    // },
    {
      key: "category",
      dataIndex: "category",
      title: "Category",
    },
    {
      key: "productName",
      dataIndex: "productName",
      title: "ProductName",
    },
    {
      key: "variety",
      dataIndex: "variety",
      title: "Variety",
    },
    {
      key: "unit",
      dataIndex: "unit",
      title: "Unit",
    },
  ];

  const dangerColumns = [
    {
      title: "Actions",
      width: 200,
      render: (text: string, record: any, index: number) => (
        <div style={{ display: "flex", gap: 12 }}>
          <Button
            type="primary"
            onClick={(e) => {
              e.stopPropagation();
              setSelectedId(record.id);
              setOpen(true);
            }}
          >
            Edit
          </Button>
        </div>
      ),
    },
  ];
  const hideModal = () => {
    setOpen(false);
    setSelectedId("");
    setSelectedStatus(undefined);
  };

  const onDelete = async () => {
    if (deleteSelectedId) {
      await deleteProdct(deleteSelectedId);
    }
    setdeleteOpen(false);
  };

  useEffect(() => {
    if (searchText) {
      const _allData = products?.data?.data?.content?.map((item: any) => {
        return {
          id: item.id,
          productName: item.productName,
          category: item.category,
          variety: item.variety,
          unit: item.unit,
        };
      });

      const _data = _allData.filter(
        (item: any) =>
          item.productName?.toLowerCase().includes(searchText.toLowerCase()) ||
          item.category?.toLowerCase().includes(searchText.toLowerCase()) ||
          item.variety?.toLowerCase().includes(searchText.toLowerCase()) ||
          item.unit?.toLowerCase().includes(searchText.toLowerCase()),
      );
      setTableData(_data);
    } else {
      if (
        products &&
        products.data &&
        products.data.data &&
        products.data.data.content
      ) {
        setTableData(products.data.data.content);
      }
    }
  }, [searchText, products]);

  const handleCreate = () => {
    setOpen(true);
  };

  return (
    <>
      <div className="hidden md:block">
        <AdminProductModal
          open={open}
          selectedId={selectedId}
          hideModal={hideModal}
        />
        <div
          style={{
            display: "flex",
            alignItems: "center",
            height: 80,
            backgroundColor: "#EEF3F8",
            borderRadius: 8.4,
            marginBottom: 12,
          }}
        >
          <TableAction
            setSearchText={setSearchText}
            onCreateNew={
              user?.roleName === "ROLE_KFT_SUPER_ADMIN"
                ? handleCreate
                : undefined
            }
          />
        </div>
        <Modal
          title={<div style={{ color: "black" }}>Confirmation</div>}
          open={deleteOpen}
          centered
          onOk={onDelete}
          onCancel={() => setdeleteOpen(false)}
          closable
          style={{ color: "black" }}
        >
          Are you sure you want to delete this product?
        </Modal>
        <Table
          style={{ cursor: "pointer" }}
          onRow={(record, index) => {
            return {
              onClick: (event) => {
                navigate(`/products/${record.id}`);
              },
            };
          }}
          dataSource={tableData}
          columns={
            roleName === "ROLE_KFT_SUPER_ADMIN"
              ? [...productsColumn, ...dangerColumns]
              : productsColumn
          }
          loading={isLoading}
        />
      </div>
      <div className="block md:hidden text-white sticky top-0">
        <Input
          onChange={(e) => setSearchText(e.target.value)}
          placeholder="Search"
          style={{ backgroundColor: "#08453E", color: "white", height: 40 }}
        />
      </div>

      <div className="w-full grid grid-col divide-y-2 divide-green-400 md:hidden px-2 mb-4">
        {tableData.map((item: any) => (
          <div className="flex justify-between items-center py-2">
            <div
              className="flex flex-col gap-1 w-[95%]"
              onClick={() => {
                navigate(`/products/${item.id}`);
              }}
            >
              <div className="flex gap-4 font-bold text-xl text-white">
                <div>{item.productName}</div>
                <div>({item.unit})</div>
              </div>
              <div className="text-gray-300">{`${item.category} - ${item.variety}`}</div>
              <div
                style={{ color: getStatusColor(item.status.toUpperCase()) }}
                className=""
              >
                {item.status}
              </div>
            </div>
            <Popover
              key={item.id}
              placement="bottomLeft"
              title={<div style={{ color: "black" }}>Actions</div>}
              content={
                <div style={{ color: "black", width: 200 }}>
                  <div
                    onClick={(e) => {
                      e.stopPropagation();
                      setSelectedId(item.id);
                      setSelectedStatus(item.status);
                      setOpen(true);
                    }}
                    style={{
                      display: "flex",
                      gap: 12,
                      alignItems: "center",
                      borderBottom: "1px solid #eee",
                      paddingBottom: 5,
                      marginTop: 15,
                      cursor: "pointer",
                    }}
                  >
                    <div>Edit</div>
                  </div>
                </div>
              }
            >
              <MoreOutlined className="text-white" />
            </Popover>
          </div>
        ))}
      </div>
    </>
  );
};

export default ProductsTable;
